export default __webpack_public_path__ + "static/media/typeP_high.1be85363.png";